var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:[
    _vm.$style.plainCard,
    _vm.headerBorderless === true ? _vm.$style.headerBorderless : '' ],style:({ backgroundColor: _vm.background !== null ? _vm.background : '' })},[_c('div',{staticClass:"card-header",class:[_vm.$style.header, _vm.headerBorder !== true ? _vm.$style.unBorder : ''],style:({ backgroundColor: _vm.background !== null ? _vm.background : '' })},[_c(_vm.headingTag,{tag:"component",style:({
        marginBottom: 0,
        padding: '.5rem 0',
        color: 'rgba(0,0,0,.5)',
        fontWeight: '500',
      })},[_vm._v(_vm._s(_vm.title))])],1),_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }